import React from "react";
import Table from "../Common/Table";
import TableFields from "../../constants/ChatDepartments/TableFields.json";
import Permission from "../Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { Pill } from "../../constants/assets/containers";
import { useHistory } from "react-router-dom";
import { isValNull } from "../../utils";

const ChatDepartmentsList = ({ list, handleClick }) => {
  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.LOGISTICS_CHAT_DEPARTMENTS];

  const getFieldValue = (item, key) => {
    switch (key) {
      case "enabled":
        return !isValNull(item[key]) ? (
          <Pill className="mr-6" isFalse={!item[key]}>
            {item[key] ? "Yes" : "No"}
          </Pill>
        ) : (
          ""
        );
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.READ, allActions.UPDATE]}
            notAllowedText="No Actions Permitted"
          >
            <span
              onClick={() => history.push(`/chat-departments/${item.id}`)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "priority":
        return !isValNull(item[key]) ? (item[key] ? "True" : "False") : "";
      default:
        return item[key];
    }
  };

  return (
    <Permission requiredPerms={[allActions.READ]}>
      <Table list={list} getFieldValue={getFieldValue} fields={TableFields} />
    </Permission>
  );
};

export default ChatDepartmentsList;
